module.exports = __webpack_public_path__ + "static/media/onboarding-bio.deb80d62.png";